import * as Sentry from '@sentry/react';

/**
 * Observability config reads ONLY from Vite build-time env:
 * VITE_SENTRY_DSN, VITE_POSTHOG_KEY, VITE_POSTHOG_HOST, VITE_RELEASE.
 * These are baked into the bundle at `npm run build` so Sentry can init
 * synchronously before React mounts — no async config fetch.
 */

const env = import.meta.env as Record<string, string | undefined>;

export const OBS_CONFIG = {
  sentryDsn: env.VITE_SENTRY_DSN,
  posthogKey: env.VITE_POSTHOG_KEY,
  posthogHost: env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
  release: env.VITE_RELEASE || 'dev',
  mode: env.MODE || 'development',
  isProd: !!env.PROD,
};

export function initSentry() {
  if (!OBS_CONFIG.sentryDsn) return;

  Sentry.init({
    dsn: OBS_CONFIG.sentryDsn,
    environment: OBS_CONFIG.mode,
    release: OBS_CONFIG.release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: OBS_CONFIG.isProd ? 0.1 : 1.0,
    replaysSessionSampleRate: OBS_CONFIG.isProd ? 0.01 : 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
  });
}

export function setObservabilityUser(customerId: string | null) {
  if (OBS_CONFIG.sentryDsn) {
    Sentry.setUser(customerId ? { id: customerId } : null);
  }
}

export { Sentry };
